/**
 * Omits specified fields from an object.
 *
 * @example
 * const originalObject = { a: 1, b: 2, c: 3 };
 * const fieldsToOmit = ['b', 'c'];
 * const result = omitFields(originalObject, fieldsToOmit);
 * console.log(result); // { a: 1 }
 */
export function omitFields(object: Record<string | number | symbol, unknown>, fields: string[]) {
    return Object.keys(object).reduce(
        (acc, key) => {
            if (!fields.includes(key)) {
                acc[key] = object[key];
            }

            return acc;
        },
        {} as Record<string | number | symbol, unknown>,
    );
}
